export default __webpack_public_path__ + "static/media/powered_by_stripe_blurple.10f380d6.svg";